// src/option_result.ts
function Ok(result) {
  var self = {
    isOk: function isOk() {
      return true;
    },
    isOkAnd: function isOkAnd(fn) {
      return fn(result);
    },
    isErr: function isErr() {
      return false;
    },
    isErrAnd: function isErrAnd() {
      return false;
    },
    ok: function ok() {
      return Some(result);
    },
    err: function err() {
      return None();
    },
    map: function map(fn) {
      return Ok(fn(result));
    },
    mapOr: function mapOr(_, fn) {
      return fn(result);
    },
    mapOrElse: function mapOrElse(_, fn) {
      return fn(result);
    },
    mapErr: function mapErr() {
      return Ok(result);
    },
    expect: function expect() {
      return result;
    },
    expectErr: function expectErr(msg) {
      throw new Error(msg);
    },
    unwrap: function unwrap() {
      return result;
    },
    unwrapErr: function unwrapErr() {
      throw new Error("".concat(result));
    },
    unwrapOr: function unwrapOr() {
      return result;
    },
    unwrapOrElse: function unwrapOrElse() {
      return result;
    },
    and: function and(res) {
      return res;
    },
    andThen: function andThen(getRes) {
      return getRes(result);
    },
    or: function or() {
      return Ok(result);
    },
    orElse: function orElse() {
      return Ok(result);
    }
  };
  return self;
}
function Err(_err) {
  var self = {
    isOk: function isOk() {
      return false;
    },
    isOkAnd: function isOkAnd() {
      return false;
    },
    isErr: function isErr() {
      return true;
    },
    isErrAnd: function isErrAnd(fn) {
      return fn(_err);
    },
    ok: function ok() {
      return None();
    },
    err: function err() {
      return Some(_err);
    },
    map: function map() {
      return Err(_err);
    },
    mapOr: function mapOr(defaultValue) {
      return defaultValue;
    },
    mapOrElse: function mapOrElse(getDefaultValue) {
      return getDefaultValue(_err);
    },
    mapErr: function mapErr(fn) {
      return Err(fn(_err));
    },
    expect: function expect(msg) {
      throw new Error(msg);
    },
    expectErr: function expectErr() {
      return _err;
    },
    unwrap: function unwrap() {
      throw new Error("".concat(_err));
    },
    unwrapErr: function unwrapErr() {
      return _err;
    },
    unwrapOr: function unwrapOr(defaultValue) {
      return defaultValue;
    },
    unwrapOrElse: function unwrapOrElse(getDefaultValue) {
      return getDefaultValue(_err);
    },
    and: function and() {
      return Err(_err);
    },
    andThen: function andThen() {
      return Err(_err);
    },
    or: function or(res) {
      return res;
    },
    orElse: function orElse(getRes) {
      return getRes(_err);
    }
  };
  return self;
}
function None() {
  var self = {
    and: function and() {
      return None();
    },
    andThen: function andThen() {
      return None();
    },
    expect: function expect(msg) {
      throw new Error(msg);
    },
    filter: function filter() {
      return self;
    },
    isSome: function isSome() {
      return false;
    },
    isSomeAnd: function isSomeAnd() {
      return false;
    },
    isNone: function isNone() {
      return true;
    },
    map: function map() {
      return None();
    },
    mapOr: function mapOr(defaultValue) {
      return defaultValue;
    },
    mapOrElse: function mapOrElse(getDefaultValue) {
      return getDefaultValue();
    },
    okOr: function okOr(err) {
      return Err(err);
    },
    okOrElse: function okOrElse(getErr) {
      return Err(getErr());
    },
    or: function or(opt) {
      return opt;
    },
    orElse: function orElse(fn) {
      return fn();
    },
    unwrap: function unwrap() {
      throw new Error("panic! call `unwrap` on a `None` value");
    },
    unwrapOr: function unwrapOr(defaultValue) {
      return defaultValue;
    },
    unwrapOrElse: function unwrapOrElse(getDefaultValue) {
      return getDefaultValue();
    },
    xor: function xor(opt) {
      if (opt.isSome()) {
        return opt;
      }
      return self;
    }
  };
  return self;
}
function Some(value) {
  var self = {
    and: function and(opt) {
      return opt;
    },
    andThen: function andThen(fn) {
      return fn(value);
    },
    expect: function expect() {
      return value;
    },
    filter: function filter(fn) {
      if (fn(value)) {
        return self;
      }
      return None();
    },
    isSome: function isSome() {
      return true;
    },
    isSomeAnd: function isSomeAnd(fn) {
      return fn(value);
    },
    isNone: function isNone() {
      return false;
    },
    map: function map(fn) {
      return Some(fn(value));
    },
    mapOr: function mapOr(_, fn) {
      return fn(value);
    },
    mapOrElse: function mapOrElse(_, fn) {
      return fn(value);
    },
    okOr: function okOr() {
      return Ok(value);
    },
    okOrElse: function okOrElse() {
      return Ok(value);
    },
    or: function or() {
      return self;
    },
    orElse: function orElse() {
      return self;
    },
    unwrap: function unwrap() {
      return value;
    },
    unwrapOr: function unwrapOr() {
      return value;
    },
    unwrapOrElse: function unwrapOrElse() {
      return value;
    },
    xor: function xor(opt) {
      if (opt.isNone()) {
        return self;
      }
      return None();
    }
  };
  return self;
}

// src/to_option.ts
function toOption(arg) {
  if (arg === null || arg === void 0) {
    return None();
  }
  return Some(arg);
}

// src/get_result.ts
function getResult(promise) {
  return promise.then(function (response) {
    return Ok(response);
  }, function (err) {
    return Err(err);
  });
}

// src/unwrap.ts
function unwrap(value) {
  if (value === null || value === void 0) {
    throw new Error("panic! call `unwrap` on a `".concat(value, "` value"));
  }
  return value;
}

// src/unwrap_or.ts
function unwrapOr(value, defaultValue) {
  if (value === null || value === void 0) {
    return defaultValue;
  }
  return value;
}

// src/unwrap_or_else.ts
function unwrapOrElse(value, getDefaultValue) {
  if (value === null || value === void 0) {
    return getDefaultValue();
  }
  return value;
}
export { Err, None, Ok, Some, getResult, toOption, unwrap, unwrapOr, unwrapOrElse };